import Vue from 'vue';

export default Vue.extend({
  name: 'roulette',
  props: {
    gifts: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    spinners: [
      {
        id: 'roulette-spinner-1',
        item: 0,
        spinning: false,
      },
      {
        id: 'roulette-spinner-2',
        item: 0,
        spinning: false,
      },
      {
        id: 'roulette-spinner-3',
        item: 0,
        spinning: false,
      },
    ],
  }),
  computed: {
    spinning(): boolean {
      return this.spinners[0].spinning || this.spinners[1].spinning || this.spinners[2].spinning;
    },
  },
  methods: {
    startRoulette(): void {
      if (!this.spinning) {
        this.$emit('spin');
      }
    },
    spinAll(earnedGift?: number): void {
      this.spinners.forEach((el, i) => setTimeout(() => this.spin(i, 3000, earnedGift), i * 300));
    },
    spin(spinnerIndex: number, time: number, earnedGift?: number): void {
      this.spinners[spinnerIndex].spinning = true;
      const spin = setInterval(() => {
        if (this.spinners[spinnerIndex].item >= this.gifts.length - 1) {
          this.spinners[spinnerIndex].item = 0;
        } else {
          this.spinners[spinnerIndex].item += 1;
        }
      }, 75 + Math.floor(Math.random() * 21));

      setTimeout(() => {
        clearInterval(spin);

        if (earnedGift !== undefined) {
          this.spinners[spinnerIndex].item = this.gifts.findIndex(
            (el: any) => el.id === earnedGift,
          );
        } else if (spinnerIndex === this.spinners.length - 1) {
          while (this.spinners[spinnerIndex].item === this.spinners[spinnerIndex - 1].item) {
            this.spinners[spinnerIndex].item = Math.floor(Math.random() * this.gifts.length);
          }
        }

        this.spinners[spinnerIndex].spinning = false;
      }, time);
    },
  },
});
